export function checkGDPR(pConfig) {
    let counter = 0;
    let detect = false;
    const interval = setInterval(() => {
        if(window["__tcfapi"]) {
            detect = true;
            __tcfapi('getInAppTCData', 2, (inAppTCData, success) => {

                if(success && inAppTCData.gdprApplies) {
                    pConfig.gdpr = true;
                    pConfig.gdprConsent = inAppTCData.tcString;
                } else {
                    __tcfapi('addEventListener', 2, (tcData, success) => {
                        if(success && tcData.gdprApplies) {
                            pConfig.gdpr = true;
                            pConfig.gdprConsent = tcData.tcString;
                        }
                    });
                }
            });
        }

        if(detect || counter > 10) clearInterval(interval);

        counter += 1;
    }, 500);
}
